import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import NotificationsReducer, {
  defaultState,
  asyncActions,
} from 'src/ducks/notifications.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(NotificationsReducer, defaultState, asyncActions);
};

type INotificationsContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const NotificationsContext = createContext<Partial<INotificationsContext>>({
  state: defaultState,
}) as React.Context<INotificationsContext>;

const NotificationsProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <NotificationsContext.Provider
      value={{
        ...reducer,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useNotificationsContext = () => useContext(NotificationsContext);

export type IUseNotificationsContext = ReturnType<
  typeof useNotificationsContext
>;

export { NotificationsContext, NotificationsProvider };
